/**
 * Browser utility functions for common browser operations
 */

/**
 * Opens a URL in a new browser tab with security best practices
 * @param url - The URL to open
 * @param features - Optional window features (default: "noopener,noreferrer")
 */
export const openNewTab = (
  url: string,
  features: string = "noopener,noreferrer"
): void => {
  window.open(url, "_blank", features);
};
